<template>
<Layout>
  <!-- 去掉多余信息 -->
  <div slot="nav"></div>
  <div slot="sub-nav"></div>
  <!-- <div slot="footer-service"></div> -->
  <div slot="wap-next"></div>
  <!-- 去掉多余信息 -->

  <!-- 导航栏 -->
  <div class="page-article" :class="{'page-talk': isTalk}">

    <div class="layout-content">

      <div class="article-fixed-operation" v-if="!isMobile && !isTalk">
        <div class="like-section">
          <p>{{info.love}}</p>
          <div class="iconfont" :class="{liked: isLike}" @click="toggleLike">&#xe67b;</div>
          <p>喜欢</p>
        </div>
        <div class="sidebar-btn-wrapper">
          <IconButton class="operation-btn" icon="favorite" label="收藏" :toggle="isFavorite" @click="toggleFavorite('sidebar')" />
          <IconButton class="operation-btn" icon="comment" label="评论" :disabled="!loginUser" v-if="!isMobile" @click="goComment" />
          <div class="share-wx" @mouseenter="touchMenuStatus = true" @mouseleave="touchMenuStatus = false">
            <IconButton class="operation-btn" icon="weixin" label="微信" />
            <transition name="slide-in-right">
              <div class="popup-box right" v-if="touchMenuStatus">
                <div class="popup-content">
                  <QrCode :size="87" :val="articleWxShareUrl" />
                </div>
              </div>
            </transition>
          </div>
          <IconButton class="operation-btn" icon="weibo" label="微博" @click="weiboShare" />
        </div>
      </div>

      <div class="article-top" v-if="!isMobile">
        <div class="article-tag">{{ info.article_subtitle }}</div>
        <h1 class="article-h1">{{ info.article_title | formatContent }}</h1>
        <div class="article-cover" v-if="info.article_cover"><img :src="info.article_cover" alt=""></div>
      </div>

      <div class="article-bottom">
        <!-- 文章id 为 25111 的文章居中显示 -->
        <div class="main-content" :style="{margin: info.aid == 25111 ? '0 auto' : '0'}">
          <component v-bind:is="curComponent" :info="info" @viewDownloadBtn="viewDownloadBtn" @weiboShare="weiboShare" @goComment="goComment" />
          <!-- isAWS 是在请求到数据之后处理之后加上去的 -->
          <p v-if="info.isAWS" class="aws-ad-tip">欲了解 AWS 的更多信息，请访问<a href="https://www.geekbang.org/page/aws2019.html" target="_blank" rel="noopener nofollow">【AWS 技术专区】</a></p>
          <!-- <div class="article-advertising" v-if="ad.src">
            <gkAdEvent :src="ad.src" :idea="ad" />
          </div> -->
          <div class="artcile-copyright" v-if="!!info.copyright">文章版权归 Google Cloud 所有，未经许可不得转载。</div>
          <ChannelTag class="channel-tag-list-pc" :list="info.topic" v-if="info.topic && !isMobile && info.aid != 25111" />
          <div class="download-btn-list" v-if="info.type == 8 && info.ebook">
            <template v-for="item in downloadMap">
              <gkButton
                v-if="info.ebook[item.alias]"
                class="download-btn"
                color="download"
                :label="`${isMobile ? '下载' : '免费下载此书'}（${item.label}）`"
                @click="downloadBook(info.ebook[item.alias], item.alias)"
                :key="item.alias"
              />
            </template>
          </div>
          <!-- 作者信息 -->
          <LeadAuthor class="lead-author-wap" :leadAuthorInfo="leadAuthorInfo" :follow="followLeadAuthor" :isTalk="isTalk"  v-if="isMobile && info.lead_author > 1" />

          <!-- 重构评论样式 文章页下方的点赞操作去掉 2019-10-23 -->
          <!-- <div ref="operationSection" class="like-section" v-if="!isTalk">
            <div class="iconfont" :class="{liked: isLike}" @click="toggleLike">&#xe686;</div>
            <p>{{info.love}} 人喜欢</p>
          </div>
          <div class="operation-btn-wrapper" v-if="!isTalk">
            <IconButton class="operation-btn" icon="favorite" label="收藏" :toggle="isFavorite" @click="toggleFavorite('bottom')" />
            <IconButton class="operation-btn" icon="comment" label="评论" :disabled="!loginUser" v-if="!isMobile" @click="goComment" />
            <div class="share-wx" @mouseenter="touchMenuStatus = true" @mouseleave="touchMenuStatus = false" v-if="!isMobile">
              <IconButton class="operation-btn" icon="weixin" label="微信" />
              <transition name="slide-in-top">
                <div class="popup-box top" v-if="touchMenuStatus">
                  <div class="popup-content">
                    <QrCode :size="87" :val="articleWxShareUrl" />
                  </div>
                </div>
              </transition>
            </div>
            <IconButton class="operation-btn" icon="weibo" label="微博" @click="weiboShare" />
          </div> -->

          <ChannelTag :class="['bottom-topic-list', {'no-border': isTalk && leadAuthorInfo}]" :list="info.topic" v-if="info.topic && isMobile && info.aid != 25111" />

          <div class="talk-share" v-if="isTalk && isMobile">
            分享到：
            <i class="iconfont" @click="weiboShare">&#xe63b;</i>
          </div>

          <div class="comment-wrapper" v-if="info.aid">
            

            <!-- <div class="unlogin-panel" v-if="(!loginUser || !loginUser.uid) && !isMobile">
              <p>注册/登录 InfoQ 发表评论</p>
              <gkButton class="login-btn" color="blue" size="big" label="注册/登录" @click="login" />
            </div> -->

            <!-- 评论开始 -->
            <template>
              <!-- 去掉精选评论 之后会有置顶的标志 -->
              <!-- <div class="top-comments comment-list" v-if="recommentComments.length">·
                <h2>精选评论</h2>
                <CommentItem v-for="comment in recommentComments" :aid="info.aid" :comment="comment" :key="comment.id" />
              </div> -->

              <!-- <MoreButton class="loading-btn" :loading="recommentLoading" :end="recommentEnd" :loadingCount="4" @click="getRecommentMore" /> -->
            </template>

            <template>
              <div class="comment-list">
                <h2 v-if="isTalk">讨论 <span class="talks-number" v-if="comments.length">({{comments.length}} 条讨论)</span></h2>
                <h2 v-else>评论</h2>
                <template v-if="isMobile">
                  <div class="comment-bottom" @click="showMobileForm">
                    <div class="text-border">{{loginUser ? !comments.length ? '快抢沙发！虚位以待' : '写下你的想法，一起交流' : '登录后发表评论'}}</div>
                    <span class="fake-submit-btn">{{loginUser ? '发表评论' : '注册/登录'}}</span>
                  </div>
                  <CommentForm
                    v-model.trim="commentValue"
                    :placeholder="!comments.length ? '快抢沙发！虚位以待' : '写下你的想法，一起交流'"
                    @close="showWapForm = false"
                    @click="submit"
                    v-if="showWapForm"
                  />
                </template>

                <template v-else>
                  <div class="comment-form">
                    <TextArea
                      ref="textarea"
                      v-model="commentValue"
                      :placeholder="!comments.length ? '快抢沙发！虚位以待' : '写下你的想法，一起交流'"
                      @empty="getTextAreaEmptyStatus"
                    />
                    <div class="comment-operation">
                      <gkButton
                        class="comment-btn"
                        color="blue"
                        size="big"
                        :label="isMobile ? '发送' : '发布'"
                        :disabled="replyBtnDisabled"
                        :use-lock="true"
                        @click="submit"
                      />
                    </div>
                  </div>
                </template>
                <div class="list" v-if="comments.length || recommentComments.length">
                  <!-- 置顶留言 -->
                  <CommentItem v-for="comment in recommentComments" :aid="info.aid" :comment="comment" :key="comment.id" /> 
                  <CommentItem v-for="comment in comments" :aid="info.aid" :comment="comment" :key="comment.id" />
                  <MoreButton :btnLabel="isMobile ? '更多评论' : '加载更多'" class="loading-btn" :loading="loading" :end="isEnd" :loadingCount="4" @click="getMore" />
                </div>
              </div>

            </template>
            <!-- 评论结束 -->

            <!-- 移动端推荐模块 -->
            <template v-if="isMobile">
              <!-- Wap 热门话题推荐 -->
              <!-- <div class="wap-talk-related" v-if="isTalk && info.relation_topic_list && info.relation_topic_list.length">
                <TalkRelated title="推荐话题" :list="info.relation_topic_list" />
              </div> -->

              <!-- <div class="wap-article-related" v-if="!isTalk && info.recommend_list && info.recommend_list.length && info.aid != 25111">
                <ArticleRelated :list="info.recommend_list" />
              </div> -->

              <!-- 7 天热门 wap -->
              <!-- <div class="wap-seven-day-hot" v-if="!isTalk && hotList.day && hotList.day.length">
                <RelatedList 
                  title="7 天热点" 
                  :list="hotList.day"
                  source="7d_hot"
                />
              </div> -->
              
              <template v-for="(box, index) in vcrBox">
                <VCRBox class="wap-vcrbox" :ad="box" :key="index" />
              </template>
            </template>
          </div>
        </div>
        <!-- PC端侧边栏推荐模块    id 为 25111 的文章 不显示侧边栏 -->
        <div class="article-sidebar"  v-if="!isMobile && info.aid != 25111">
          <!-- <HomeWeek class="article-week" /> -->

          <!-- 文章信息 -->
          <div class="article-info article-detail" v-if="!isMobile">
            <div class="article-info-title">文章信息</div>
            <div class="article-info-author-name" v-if="info.no_author">{{ info.no_author }}</div>
            <template v-if="info.author">
              <span v-for="author in info.author" :key="author.uid" class="article-info-author-name">
                {{ author.nickname }}
              </span>
            </template>
            <!-- <div class="article-info-author-position">{{ info.no_author }}</div> -->
            <div class="article-info-author-position">
              <!-- <ul class="author">
                <template v-if="info.author">
                  <li v-for="author in info.author" :key="author.uid">
                    <AuthorName :uid="author.uid" :name="author.nickname" />
                  </li>
                </template>
                <template v-else>
                  <li>佚名</li>
                </template>
              </ul> -->
              <template v-if="info.translator && !isMobile">
                <!-- <div class="divider"></div> -->
                <ul class="translate">
                  <li v-for="translator in info.translator" :key="translator.uid">
                    {{ translator.nickname }}
                  </li>
                </ul>
              </template>
              <template v-if="info.planner && !isMobile">
                <div class="divider"></div>
                <ul class="planner">
                  <li v-for="planner in info.planner" :key="planner.uid">
                    <AuthorName :uid="planner.uid" :name="planner.nickname" />
                  </li>
                </ul>
              </template>
            </div>
            <div class="article-info-views">{{ info.views }}次阅读</div>
            <div class="article-info-date">{{ info.publish_time | date('YYYY 年 M 月 D 日 hh:mm') }}</div>
          </div>

          <!-- 作者信息 -->
          <!-- <LeadAuthor class="lead-author-pc" 
            :leadAuthorInfo="leadAuthorInfo" 
            :follow="followLeadAuthor"  
            :isTalk="isTalk"
            v-if="info.lead_author > 1"
          /> -->

          <!-- PC 热门话题推荐 -->
          <!-- <TalkRelated class="sidebar-related" title="推荐话题" :list="info.relation_topic_list" v-if="isTalk && info.relation_topic_list && info.relation_topic_list.length">
            <a href="" slot="more" class="more" @click="routeTalks">
              全部话题 <i class="iconfont">&#xe62f;</i>
            </a>
          </TalkRelated> -->
          
          <!-- 推荐阅读 -->
          <!-- <ArticleRelated class="sidebar-related" :list="info.recommend_list" v-if="!isTalk && info.recommend_list && info.recommend_list.length"/> -->
          <!-- 7 天热门 -->
          <!-- <RelatedList 
            class="seven-day-hot-pc sidebar-related" 
            title="7 天热点" 
            :list="hotList.day"
            source="7d_hot"
            v-if="!isTalk && hotList.day && hotList.day.length"
          /> -->
          <!-- 每周精要 -->
          <!-- <ComWeeklyPanel class="article-week" ref="articleWeek" /> -->
          <!-- VCRBox -->
          <div class="vcr-box">
            <template v-for="(box, index) in vcrBox">
              <VCRBox class="sidebar-vcrbox" :ad="box" :key="index" />
            </template>
          </div>
        </div>
      </div>

    </div>
    <GoTop class="return-top" />
    <transition name="fade">
      <div class="publish-success" v-if="publishSuccess">
        <i class="iconfont">&#xe615;</i>
        发布成功！
      </div>
    </transition>
  </div>
</Layout>
</template>

<script>
import {mapState, mapMutations, mapActions} from 'vuex'
import scroller from 'vue-scrollto'
import utils from '../../utils/'
import errorCode from '../../utils/errorCode'

import Layout from '../../components/layout/Layout'
import TopicTag from '../../components/list/TopicTag'
import ChannelTag from '../../components/list/ChannelTag'
import gkButton from 'gkui/button'
import gkAdEvent from 'gkui/ad/ADEvent'
import MoreButton from '../../components/button/MoreButton'
import IconButton from '../../components/button/IconButton'
import Avatar from '../../components/Avatar'
import ListItem from '../../components/list/List.Item'
import ArticleImage from '../../components/list/ArticleImage'
import AuthorName from '../../components/title/AuthorName'
import TopicTitle from '../../components/title/TopicTitle'
import QrCode from '../../components/qrcode'
import GoTop from '../../components/gotop/GoTop'
import TextArea from '../../components/textarea/TextArea'

import ArticleRelated from './ArticleRelated'
import VCRBox from '../../components/ad/VCRBox'
import ArticleContent from './ArticleContent'
import BookContent from './BookContent'
import TalkContent from './TalkContent'
import CommentForm from './CommentForm'
import CommentItem from './CommentItem'
import LeadAuthor from './LeadAuthor'
import TalkRelated from '../talks/Talk.Hot'
import RelatedList from '../../components/list/RelatedList'

import HomeWeek from '../home/Home.Week'
import ComWeeklyPanel from '../../components/weekly/Weekly'

import ArticleService from '../../service/article.service'
import ConfigService from '../../service/config.service'
import HomeService from '../../service/home.service'

export default {
  name: 'page-article',
  components: {
    Layout,
    TopicTag,
    ChannelTag,
    gkButton,
    gkAdEvent,
    MoreButton,
    IconButton,
    Avatar,
    ListItem,
    ArticleImage,
    AuthorName,
    TopicTitle,
    QrCode,
    GoTop,
    ArticleRelated,
    VCRBox,
    ArticleContent,
    BookContent,
    TalkContent,
    CommentForm,
    CommentItem,
    LeadAuthor,
    TalkRelated,
    HomeWeek,
    ComWeeklyPanel,
    RelatedList,
    TextArea
  },
  data () {
    return {
      info: {},
      leadAuthorInfo: {},
      ad: {},
      vcrBox: {},
      hotList: {},
      curComponent: null,
      isLike: 0,
      isFavorite: 0,
      loading: false,
      hotLoading: false,
      score: null,
      isEnd: false,
      relatedList: [],
      comments: [],
      commentValue: '',
      recommentLoading: false,
      recommendCommentsScore: null,
      recommentEnd: false,
      recommentComments: [],
      showFixedOperation: true,
      showWapForm: false,
      touchMenuStatus: false,
      followLeadAuthor: false,
      publishSuccess: false,
      replyBtnDisabled: true
    }
  },
  computed: {
    ...mapState(['isMobile', 'loginUser', 'isBottom']),
    isTalk () {
      return this.$route.name === 'talk'
    },
    articleTypeLabel () {
      return this.info.type === 1 ? 'article' : this.info.type === 8 ? 'ebook' : ''
    },
    articleID () {
      return this.$route.params.id
    },
    articleWxShareUrl () {
      return `https://www.infoq.cn${this.$route.path}?utm_source=wxshare`
    },
    downloadMap () {
      return [
        {
          alias: 'pdf',
          label: 'PDF'
        },
        {
          alias: 'epub',
          label: 'ePub'
        },
        {
          alias: 'mobi',
          label: 'MOBI'
        }
      ]
    }
  },
  watch: {
    /**
     * 默认为 null 以防数据为 null 时导致渲染错误
     */
    info: {
      handler (info) {
        if (this.isTalk) {
          this.curComponent = TalkContent
        } else {
          if (info.type) {
            this.curComponent = info.type === 1 ? ArticleContent : BookContent
          }
        }

        info.aid && this.getCommentList()
        info.aid && this.getRecommendCommentList()

        // 如果为初始值则获取 info 的数据，否则数据不变
        this.isLike = this.isLike === 0 ? info.is_love : this.isLike
        this.isFavorite = this.isFavorite === 0 ? info.is_collect : this.isFavorite
      },
      deep: true
    },
    // ,
    // showWapForm (visable) {
    //   visable ? utils.fixedBody.open() : utils.fixedBody.close()
    // }
    /**
     * 判断是否滑动到底部
     */
    isBottom () {
    },
    publishSuccess (show) {
      if (show) {
        setTimeout(() => {
          this.publishSuccess = false
        }, 2000)
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    ConfigService.initAdvertising().then(() => {
      next()
    }).catch(() => {
      next()
    })
  },
  created () {
    this.getInfo(this.articleID)
    /**
     * 请求热点列表
     */
    this.getHotList()
  },
  mounted () {
    this.setIsArticlePage(true)
    // window.addEventListener('scroll', utils.throttle(this.listenerScroll))

    if (this.$route.query.utm_source === 'wxshare') {
      window.ga && window.ga('send', 'event', 'wxshare', this.articleWxShareUrl, this.loginUser.uid || 'guest')
    }
    /**
     * 需要登录的接口跳到账户中心登录成功之后 需要做一些动作的回调
     * request 方法option 添加extra 额外的数据 {type: 'publishComment', message: '发布成功'}
     * @see article.service.js 中 addComment 方法
     */
    this.getPageAction((options) => {
      if (options.type === 'publishComment') {
        this.publishSuccess = true
      }
    })
  },
  beforeDestroy () {
    this.setIsArticlePage(false)
    // window.removeEventListener('scroll', utils.throttle(this.listenerScroll))
  },
  methods: {
    ...mapMutations({
      setIsArticlePage: 'IS_ARTICLE_PAGE'
    }),
    ...mapActions(['getPageAction']),
    /**
     * 监听 scroll
     * 判断是否已到操作区
     * 文章页左边操作条 一直悬浮 2019.10.23
     */
    listenerScroll (event) {
      const operationCom = this.$refs.operationSection
      this.showFixedOperation = operationCom && operationCom.getBoundingClientRect().top > window.innerHeight
    },
    /**
     * 获取广告信息
     */
    getAD (id, topic) {
      ConfigService.getArticleAD(id, topic).then(res => {
        this.ad = res
      })
    },
    /**
     * 获取 7 天热点  取首页的基础列表接口
     * 获取首页各个模块的列表
     * 包含精选内容、热点和迷你书
     */
    getHotList () {
      this.hotLoading = true

      HomeService.baseList().then(res => {
        this.hotLoading = false

        this.hotList = {
          day: res.hot_day_list,
          month: res.hot_month_list,
          year: res.hot_year_list
        }
      })
    },
    /**
     * 获取 VCRBox 广告信息
     */
    getVcrbox (id, topic) {
      // ConfigService.getArticleVcrbox(id, topic).then(res => {
      //   this.vcrBox = res
      // })
      this.vcrBox = [
        {
          label: '相关推荐',
          ideas: [
            {
              src: "https://static001-test.geekbang.org/resource/image/dd/43/dd3a53ee5a75648a0a6ef9f443635243.jpg",
              route: "https://www.infoq.cn/zones/google/cloud/?utm_source=VCR&utm_medium=youce",
              visible: "",
              click: "",
              desc: "K8s容器编排、数据导入与查询、云迁移上手攻略",
              ideaType: 2
            },
            {
              src: "",
              route: "https://www.infoq.cn/zones/google/cloud/article/RJXSj4YXSjpac9Qh6W7R/?utm_source=VCR&utm_medium=youce",
              visible: "",
              click: "",
              desc: "Microsoft SQL Server 工作负载迁移至 Google Cloud",
              ideaType: 4
            },
            {
              src: "",
              route: "https://www.infoq.cn/zones/google/cloud/article/I4p8XqAjlBwMQOt9WB7g/?utm_source=VCR&utm_medium=youce",
              visible: "",
              click: "",
              desc: "白皮书 | Anthos 实现应用程序安全现代化的绝佳机遇",
              ideaType: 4
            },
            {
              src: "",
              route: "https://www.infoq.cn/zones/google/cloud/article/m9WFHV6D0EWDFpGkByx4/?utm_source=VCR&utm_medium=youce",
              visible: "",
              click: "",
              desc: "白皮书 | 在 Google Cloud Platform 上操作数据删除",
              ideaType: 4
            },
            {
              src: "",
              route: "https://www.infoq.cn/zones/google/cloud/article/W1lDNNZvglcaOHkXCfpP/?utm_source=VCR&utm_medium=youce",
              visible: "",
              click: "",
              desc: "白皮书 | Google Cloud 数据突发事件响应流程",
              ideaType: 4
            },
            {
              src: "",
              route: "https://www.infoq.cn/zones/google/cloud/article/B5DBf7kOVhshFpPKCTUN/?utm_source=VCR&utm_medium=youce",
              visible: "",
              click: "",
              desc: "技术指南 | Google Cloud 导入标准 CentOS 镜像",
              ideaType: 4
            }
          ]
        }
      ]
    },
    /**
     * 获取文章详情
     */
    getInfo (id) {
      ArticleService.getArticleDetail(id).then(res => {
        this.info = res
        if (res.lead_author > 1) {
          this.getAuthorIntro(res.aid, res.lead_author)
        }

        if (this.$route.hash.indexOf('download') !== -1) {
          this.$nextTick(() => {
            scroller.scrollTo('.download-btn-list', {
              offset: -300
            })
          })
        }

        // 话题不需要显示广告
        if (!this.isTalk) {
          this.getAD(res.aid, res.topic.map(topic => topic.name))
          this.getVcrbox(res.aid, res.topic.map(topic => topic.name))
        }
        // this.$emit('updateHead')
      }).catch(error => {
        try {
          if (error.api === 1) {
            return
            this.$router.replace('/404')
          }
        } catch (err) {}
      })
    },
    /**
     * 下载电子书
     */
    downloadBook (url, type) {
      if (!this.loginUser) {
        utils.login()
        return
      }

      window.ga && window.ga('send', 'event', `${type} 电子书`, 'click', url)
      window.open(url)
    },
    /**
     * 手动获取新数据
     */
    getMore ({clear}) {
      this.getCommentList().then(() => {
        clear && clear()
      })
    },
    /**
     * 手动获取精选留言新数据
     */
    getRecommentMore ({clear}) {
      this.getRecommendCommentList().then(() => {
        clear && clear()
      })
    },
    /**
     * 获取评论列表
     */
    getCommentList () {
      if (this.isEnd || this.loading) {
        return
      }

      let postData = {
        id: this.info.aid,
        score: this.score
      }

      this.loading = true

      return ArticleService.getCommentList(postData).then(res => {
        const {list} = res
        this.loading = false
        this.comments = [...this.comments, ...list]
        this.isEnd = !this.comments.length || !list.length || !res.page.hasmore

        if (!this.isEnd) {
          this.score = list.length
                     ? list[list.length - 1].score
                     : this.comments[this.comments.length - 1].score
        }
      }).catch(() => {
        this.loading = false
      })
    },
    /**
     * 获取精选留言列表
     */
    getRecommendCommentList () {
      if (this.recommentLoading) {
        return
      }

      let postData = {
        id: this.info.aid,
        score: this.recommendCommentsScore
      }

      this.recommentLoading = true

      return ArticleService.getRecommendCommentList(postData).then(list => {
        this.recommentLoading = false
        this.recommentComments = [...list]
      }).catch(() => {
        this.recommentLoading = false
      })
    },
    /**
     * 收藏/取消收藏文章
     * @param {String}    position          触发收藏位置  用于GA统计
     */
    toggleFavorite (position) {
      !this.isFavorite && window.ga && window.ga('send', 'event', '文章新增收藏数', `${this.articleTypeLabel}-${position}`)

      ArticleService.favoriteArticle(this.info.aid, !this.isFavorite).then(res => {
        this.isFavorite = !this.isFavorite
      })
    },
    /**
     * 跳转到到评价区
     */
    goComment () {
      // if (!this.loginUser) {
      //   utils.login()
      // }
      if (this.isMobile) {
        this.showMobileForm()
      } else {
        this.$refs.textarea.focus()
      }
    },
    /**
     * 喜欢/取消喜欢文章
     */
    toggleLike () {
      ArticleService.likeArticle(this.info.aid, !this.isLike, 1).then(res => {
        this.isLike = !this.isLike
        this.isLike ? this.info.love++ : this.info.love--
      })
    },
    /**
     * 分享到微博
     */
    weiboShare () {
      utils.weiboShare({url: location.href, title: this.info.article_title, image: this.info.article_cover})
    },
    /**
     * 跳转到登录页面
     */
    login () {
      window.ga && window.ga('send', 'event', `「注册/登录」按钮`, `${this.isTalk ? '话题' : '文章'}页`, `pc ${this.info.article_title}`)
      utils.login()
    },
    /**
     * 提交评论
     */
    submit ({clear}) {
      const isHasContent = /[^\n\s]+/g.test(this.commentValue)

      if (!isHasContent) {
        this.$Message.toast({
          message: '请输入内容'
        })
        clear && clear()
        return
      }

      const postData = {
        aid: this.info.aid,
        content: this.commentValue
      }

      if (!this.loginUser) {
        this.$modal.confirm({
          center: true,
          verticalCenter: true,
          message: '登录后可直接发布评论',
          width: 280,
          top: '140px',
          dialogClass: 'login-action-confirm'
        }).then(res => {
          if (res.ok) {
            res.close()
            this.publishComment(postData, clear)
          } else {
            clear && clear()
            res.close()
          }
        })
      } else {
        this.publishComment(postData, clear)
      }
    },
    /**
     * 发布评论方法
     */
    publishComment (postData, clear) {
      ArticleService.addComment(postData, {type: 'publishComment', message: '发布成功！'}).then(res => {
        this.comments = [res, ...this.comments]
        this.publishSuccess = true
        if (this.isMobile) {
          this.showWapForm = false
        }
        this.commentValue = ''

        clear && clear()
      }).catch(error => {
        if (error.api === 1 && errorCode[error.code]) {
          this.$Message.toast({
            message: errorCode[error.code]
          })
        }

        clear && clear()
      })
    },
    /**
     * 页面滚动到 下载电子书按钮
     */
    viewDownloadBtn () {
      window.ga && window.ga('send', 'event', '顶部电子书下载点击', 'click')
      scroller.scrollTo('.download-btn-list', {
        offset: -300
      })
    },
    /**
     * 获取作者详情
     */
    getAuthorIntro (aid, authorId) {
      ArticleService.getLeadAuthorInfo(aid, authorId).then(res => {
        this.leadAuthorInfo = res
        this.followLeadAuthor = res.is_sub
      }).catch(() => {
        this.leadAuthorInfo = undefined
      })
    },
    /**
     * 显示移动端评论框
     */
    showMobileForm () {
      if (this.loginUser) {
        this.showWapForm = true
      } else {
        window.ga && window.ga('send', 'event', `「注册/登录」按钮`, `${this.isTalk ? '话题' : '文章'}页`, `pc ${this.info.article_title}`)
        utils.login()
      }
    },
    /**
     * 跳转全部话题页
     */
    routeTalks () {
      window.open('https://www.infoq.cn/talks')
    },
    getTextAreaEmptyStatus (status) {
      this.replyBtnDisabled = status
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/common';
.layout-content {
  width: 1080px;
  @media screen and (max-width: 768px) {
    width: 100%;
  }
}

.more {
  position: relative;
  @include lineFont(14, 400);
  line-height: 12px;
  color: $gray;
  cursor: pointer;

  & .iconfont {
    margin-left: -3px;
    @include lineFont(13, 400);
    color: $gray;
    cursor: pointer;
  }

  &:hover,
  &:hover .iconfont {
    color: $blue;
  }
}

.publish-success {
  @extend %center;
  position: fixed; z-index: 1000; top: 50%; left: 50%;
  width: 258px; height: 98px;
  background: #f8fafe;
  border: 1px solid #e7effe; border-radius: 6px;
  @include lineFont(16, 500);
  color: $blue;
  transform: translate(-50%, -50%);

  & .iconfont {
    margin-right: 7px;
    font-size: 24px;
  }
}

.page-article {
  padding: 56px 0 40px;
  background: #FFF;

  & .article-bottom {
    display: flex;
    justify-content: space-between;
  }
}

.page-talk {
  padding-top: 37px;
}

.article-top {
  margin-bottom: 49px;
  .article-tag {
    color: #5F6368;
    font-weight: 500;
  }
  .article-h1 {
    color: #202124;
    font-size: 28px;
    font-weight: 500;
    line-height: 36px;
    margin-top: 10px;
    margin-bottom: 30px;
  }
  .article-cover {
    width: 100%;
    padding-bottom: 40.7%;
    overflow: hidden;
    position: relative;
    border-radius: 5px;
    img {
      position: absolute; top: 50%; transform: translateY(-50%);
      width: 100%;
    }
  }
}

.main-content {
  position: relative;
  width: 736px; min-height: 600px;
  margin: 0;

  & .aws-ad-tip {
    padding: 15px 0;
    @include lineFont(14);
    line-height: 24px;
    color: $gray;
  }

  & .artcile-copyright {
    @include lineFont(14);
    color: $gray;
  }
}
.channel-tag-list-pc,
.com-topic-tag {
  margin: 28px 0 36px;
}

.article-advertising {
  padding-bottom: 35px; margin-bottom: 21px;
  border-bottom: 1px solid $borderGray;
}

.download-btn-list {
  @extend %center;
  padding: 4px 0 12px;

  & .download-btn {
    width: 168px; height: 36px;
    margin: 0 16px;
    border-radius: 36px;
  }
}

.article-fixed-operation {
  position: fixed; left: 50%; top: calc(50% + 60px); z-index: 300;
  margin-left: -654px;
  transform: translateY(-50%);

  & .like-section {
    height: 65px;
    padding-top: 0;

    & p {
      @include lineFont(12, 400);
    }
  }

  & .sidebar-btn-wrapper {
    width: 40px;
    margin: 0 auto;
  }

  & .operation-btn {
    margin-top: 15px;
  }
}

.like-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  height: 92px;
  // padding-top: 30px;
  color: $gray;

  & .iconfont {
    box-sizing: border-box;
    @extend %center;
    // width: 44px; height: 44px;
    // background: $lightGray;
    // border: 1px solid $lightGray;
    border-radius: 64px;
    @include lineFont(21, 400);
    color: #202124;
    cursor: pointer;
    @extend %transition;

    &:hover {
      // border: 1px solid $blue; 
      background: #FFF;
      color: #202124;
    }

    &.liked {
      // background: $blue;
      color: $blue;
      // border: 1px solid $blue;

      & + p {
        color: $blue;
      }
    }
  }

  & p {
    @include lineFont(13, 400);
  }
}

.operation-btn-wrapper {
  @extend %center;
  padding-top: 20px;

  & .operation-btn {
    margin: 0 38px;
  }
}

.article-sidebar {
  position: relative;
  // position: fixed; left: 50%; top: 135px;
  width: 296px;
  // margin-left: 244px;
}

// 文章信息
.article-info {
  box-sizing: border-box;
  width: 100%;
  padding: 16px 20px 15px;
  background: #FFF;
  border: 1px solid $borderGray; border-radius: 3px;
  margin-bottom: 20px;
  .article-info-title {
    position: relative;
    height: 34px;
    padding-bottom: 5px;
    line-height: 34px;
    // text-indent: 12px;
    @include font(20, 500);
    color: $lightBlack;
  }
  .article-info-author-name {
     @include font(16, 600);
    color: #202124;
    line-height: 21px;
  }
  .article-info-author-position,
  .article-info-views,
  .article-info-date {
    @include font(14, 400);
    color: #757575;
    line-height: 21px;
    margin-bottom: 18px;
  }
  .article-info-author-position {
    display: inline-flex;
    align-items: center;
  }
}

.article-detail {
  & .author,
  & .translate,
  & .planner {
    display: flex;
    flex-wrap: wrap;
    
    & li {
      margin-right: 4px;
      color: $black;

      &:before {
        content: ', '
      }

      &:first-child:before {
        content: ' ';
      }
    }
  }

  & .author:before {
    content: '作者：';
  }
  & .translate:before {
    content: '译者：';
  }
  & .planner:before {
    content: '策划：';
  }

  & .divider {
    &:before {
      content: ' ';
      display: block;
      position: relative;
      margin: 0 15px 0 7px;
      // top: 2px;
      width: 1px;
      height: 8px;
      background: $gray;
    }
  }
}


.related-fixed {
  // position: sticky; top: 96px; right: 0;
  width: 296px;
  @extend %transition;

  &.fixed {
    position: fixed; top: 97px;
  }

  &.is-bottom {
    position: absolute;
    top: auto; bottom: 0;
    @extend %transition;
  }
}
.sidebar-related,
.lead-author-pc,
.article-week,
.seven-day-hot-pc
.sidebar-vcrbox {
  margin-bottom: 20px;
}

.vcr-box {
  position: sticky; top: 97px;
}

.comment-wrapper {
  position: relative;
  // padding-top: 80px;
}
.page-talk .comment-wrapper {
  // padding-top: 8px;
}

.comment-form {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  position: relative;
  padding-bottom: 4px;


  &.unlogin-form {
    opacity: 0.4;
    pointer-events: none;
  }

  & .comment-operation {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-left: 20px;

    & .comment-btn{
      width: 63px; height: 36px;
      border-radius: 4px;

      &[disabled] {
        background: #94BAFF;
      }
    }
  }

  & .comment-error {
    position: absolute; left: 0; bottom: 0;
    @include lineFont(12, 400);
    color: $orange;
  }

  & .comment-btn {
    width: 100px;
    // margin: 15px 0 0 auto;
  }
}

.unlogin-panel {
  padding: 15px 0 20px;
  line-height: 47px;
  text-align: center;
  @include font(18, 400);
  color: $black;

  & p {
    letter-spacing: 1.8px;
  }

  & .login-btn {
    width: 102px;
    margin: 0 auto;
  }
}

.comment-list {
  // padding-top: 36px;

  & h2 {
    position: relative;
    padding-bottom: 16px;
    text-indent: 12px;
    @include lineFont(20, 600);
    color: $lightBlack;

    &:before {
      content: ' ';
      display: block;
      position: absolute; left: 0; top: 0;
      width: 4px; height: 18px;
      border-radius: 4px;
      background: $blue;
    }

   & .talks-number {
     font-size: 18px;
   }
  }

  & .list ::v-deep .comment-item:first-child {
    border-top: none;
  }

  & .list {
    & ::v-deep .comment-item {
      position: relative;
      padding: 16px 0 16px 52px;
      border-top: 1px solid $borderGray;

      & .comment-avatar {
        position: absolute; left: 0; top: 14px;
      }
    }
  }
}

.return-top {
  margin-left: 555px;
}
@media screen and (max-width: 1280px) {
  .article-fixed-operation {
    margin-left: -620px;
  }
}

@media screen and (max-width: 768px) {
  .page-article {
    padding: 0 20px 15px;
  }
  .main-content {
    width: 100%;

    & .artcile-copyright {
      @include lineFont(12);
    }
  }

  .article-advertising {
    padding-bottom: 20px; margin-bottom: 10px;
  }

  .comment-wrapper {
    padding-top: 8px;
  }

  .page-talk .article-advertising {
    margin-bottom: 0;
    border-bottom: none;
  }

  .talk-share {
    height: 16px;
    margin: -1px 0 18px;
    line-height: 1;
    font-size: 14px;
    color: #828A92;

    & .iconfont {
      position: relative; left: -3px; top: 1px;
      font-size: 19px;
      color: #EA5B48;
    }
  }

  .operation-btn-wrapper {
    padding-bottom: 24px;

    & .operation-btn {
      margin: 0 24px;
    }
  }

  .lead-author-wap {
    margin-top: 28px;
  }

  .like-section {

    & .iconfont {

      &:hover {
        background: $lightGray;
        border: 1px solid $lightGray;
        color: $gray;
      }

      &.liked,
      &.liked:hover {
        background: $blue;
        border: 1px solid $blue;
        color: #FFF;
      }
    }

    & p {
      @include lineFont(14, 400);
    }
  }

  .download-btn-list {
    justify-content: space-between;
    padding: 36px 0 12px;

    & .download-btn {
      width: 98px; height: 30px;
      margin: 0;
      @include lineFont(12, 400);
    }
  }

  .bottom-topic-list {
    padding: 24px 0; margin: 0;
    // border-top: 1px solid $borderGray;

    &.no-border {
      border-top: none;
    }
  }

  .unlogin-panel {
    padding-top: 0;
  }

  .wap-talk-related,
  .wap-seven-day-hot,
  .wap-article-related {
    margin: 0 -20px;
    border-top: 15px solid #F6F7F9;
  }

  .wap-vcrbox.vcrbox-panel {
    width: auto;
    padding: 16px 20px 30px; margin: 0 -20px;
    border-top: 15px solid #F6F7F9;
  }

  .wap-recommond-item ::v-deep .image {
    flex: auto 0 0; height: 90px;
    margin-left: 24px;
    
    & img {
      width: 135px; height: 90px;

      &.book-image {
        width: auto;
      }
    }
  }

  // .comment-wrapper {
  //   padding: 0 0 15px;
  // }

  .comment-bottom {
    box-sizing: border-box;
    position: fixed; left: 0; bottom: 0; right: 0; z-index: 10;
    display: flex;
    align-items: center;
    height: 50px;
    padding: 0 20px;
    background: #F3F9FF;
    // line-height: 50px;
    text-align: right;
    color: $black;

    & .text-border {
      flex: 1;
      box-sizing: border-box;
      height: 36px;
      margin-right: 15px;
      background: #FFF;
      border-radius: 3px;
      line-height: 36px;
      text-align: left;
      text-indent: 10px;
      @include font(14, 400);
      color: $gray;
    }

    & .fake-submit-btn {
      height: 36px;
      padding: 0 16px;
      background: $blue;
      border-radius: 36px;
      line-height: 36px;
      color: #fff;
    }
  }

  .comment-list {
    padding: 15px 20px 0; margin: 0 -20px;
    border-top: 15px solid $lightGray;

    & h2 {
      padding-bottom: 17px;
      text-indent: 12px;
      @include lineFont(20, 500);

      &:before {
        height: 18px;
      }
    }

    & .list {
      margin-top: -11px;

      & ::v-deep .loading-btn {
        margin-bottom: 20px;
      }

      & ::v-deep .loading-btn [gk-button] {
        width: 90px; height: 30px;
        color: #8a8a8a;
        border-radius: 30px;
      }
      & ::v-deep .comment-item {
        padding: 14px 0 14px 38px;
        border-top: none;

        & .comment-avatar {
          top: 14px;
        }
      }
    }
  }
}

.share-wx {
  position: relative;
  cursor: pointer;

  &:hover {
    & .com-icon-button {
      // color: $blue;
    }
    & .com-icon-button ::v-deep [gk-button] {
      background: #FFF;
      // color: $blue;
    }
  }

  & .popup-box {
    position: absolute; left: -20px; bottom: 20px; z-index: 300;
    
    & .popup-content {
      box-sizing: border-box;
      position: relative;
      // padding: 30px;
      padding: 10px;
      background: #FFF;
      border: 1px solid $borderGray; border-radius: 3px;
      box-shadow: $shadowGray;
      cursor: default;

      &:before,
      &:after {
        content: ' ';
        display: block;
        position: absolute;
        width: 0; height: 0;
      }

    }

    &.top {
      left: 4px;
      padding-bottom: 60px;

      & .popup-content {
        &:before,
        &:after {
          left: 50%;
          transform: translateX(-50%);
        }

        &:before {
          bottom: -9px;
          border-top: 8px solid $borderGray;
          border-left: 8px solid transparent;
          border-right: 8px solid transparent;
        }

        &:after {
          bottom: -8px;
          border-top: 8px solid #FFF;
          border-left: 8px solid transparent;
          border-right: 8px solid transparent;
        }
      }
      
    }

    &.right {
      top: -34px;
      padding-left: 80px;

      & .popup-content {
        &:before,
        &:after {
          top: 50%;
          transform: translateY(-50%);
        }

        &:before {
          left: -17px;
          border: 8px solid transparent;
          border-right-color: $borderGray;
        }

        &:after {
          left: -16px;
          border: 8px solid transparent;
          border-right-color: #fff;
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .publish-success {
    width: 200px; height: 80px;
  }

  .share-wx {
    & .popup-box {
      &.top {
        left: -34px;
        padding-bottom: 20px;
      }
    }
  }
}

.slide-in-top-enter-active,
.slide-in-top-leave-active,
.slide-in-right-enter-active,
.slide-in-right-leave-active {
  transition: all 0.3s ease;
}
.slide-in-top-enter,
.slide-in-top-leave-to {
  transform: translateY(5px);
  opacity: 0;
}


.slide-in-right-enter,
.slide-in-right-leave-to {
  transform: translateX(-5px);
  opacity: 0;
}
</style>

 